import React from 'react';
// import App from '../App'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import CollectionList from '../../pages/CollectionList';
import CollectionsDetail from '../../pages/CollectionsDetail';
import add from '../../pages/Package/add';

const Routes = (props: any) => {
    return (
        <Switch>
            <Route path="/package/detail/:org/:name" component={CollectionsDetail}/>
            <Route path="/package/detail/:name" component={CollectionsDetail}/>
            <Route path="/package/add" component={add}/>
        </Switch>
  )
}
export default Routes
